<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsFeatureTags")
    h1.title Sortierung im Buchungskalender
    .sub-headline Hier können Sie die Sortierung der Ausstattung im Buchungskalender manipulieren.

    .card.margin-top
      #main
        b-table(
                :data="featureTagsSorted"
                default-sort-direction="adminSortOrder"
                draggable
                @dragstart="dragstart"
                @drop="drop"
                @dragover="dragover"
                @dragleave="dragleave"
              )
          b-table-column(field='name' label='Name' v-slot="props")
            | {{ props.row.name }}
</template>

<script> 
export default {
  data() {
    return {
      featureTagsSorted: [],
      draggingRow: null,
      draggingRowIndex: null,
    };
  },
  computed: {
    featureTags() {
      return this.$store.state.featureTags.all;
    }
  },
  methods: {
    dragstart (payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index
      await this.$store.dispatch("featureTags/updateAdminOrder", {
        id: this.featureTagsSorted[this.draggingRowIndex].id,
        position: droppedOnRowIndex
      });
      await this.$store.dispatch("featureTags/findAll");
      this.featureTagsSorted = JSON.parse(JSON.stringify(this.featureTags)).sort((a, b) => a.adminSortOrder - b.adminSortOrder);
      this.$buefy.toast.open(`Verschoben von Position ${this.draggingRowIndex + 1} auf ${droppedOnRowIndex + 1}`)
    }
  },
  async mounted() {
    await this.$store.dispatch("featureTags/findAll");
    this.featureTagsSorted = JSON.parse(JSON.stringify(this.featureTags)).sort((a, b) => a.adminSortOrder - b.adminSortOrder);
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>